<template>
  <div class="guoqi">
    <!-- ============ 顶部 Hero：平安橙情感锚点 + 科技装饰 ============ -->
    <section class="hero">
      <div class="halo halo-a"></div>
      <div class="halo halo-b"></div>
      <div class="ring ring-a"></div>
      <div class="ring ring-b"></div>
      <div class="tech-dots"></div>

      <div class="hero-badge">
        <span class="badge-dot"></span>
        智能风控 · 国资安全
      </div>
      <h1 class="hero-title">守护国企贸易安全合规</h1>
      <p class="hero-sub">智能合规 · 智慧风控</p>

      <div class="hero-stats">
        <div class="hero-stat">
          <div class="num"><b>{{ soeTotal }}</b><em>家</em></div>
          <div class="lbl">收录涉假企业</div>
        </div>
        <div class="hero-stat">
          <div class="num"><b>98.6</b><em>%</em></div>
          <div class="lbl">AI 识别准确率</div>
        </div>
        <div class="hero-stat">
          <div class="num"><b>7×24</b></div>
          <div class="lbl">实时风险监测</div>
        </div>
      </div>
    </section>

    <!-- ============ 四大核心服务 ============ -->
    <main class="main">

      <!-- ============ 快速入口 ============ -->
      <nav class="quick-nav">
        <div class="quick-item" @click="scrollToService('cardComp')">
          <div class="quick-icon theme-comp">
            <svg viewBox="0 0 48 48" width="30" height="30" aria-hidden="true">
              <rect x="8" y="6" width="32" height="38" rx="5" fill="none" stroke="#fff" stroke-width="3.4" />
              <rect x="17" y="4" width="14" height="8" rx="2" fill="#fff" />
              <path d="M18 25l5 5 8-9" fill="none" stroke="#fff" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <span class="quick-name">合规自查表</span>
        </div>
        <div class="quick-item" @click="scrollToService('cardSoe')">
          <div class="quick-icon theme-soe">
            <svg viewBox="0 0 48 48" width="30" height="30" aria-hidden="true">
              <circle cx="20" cy="20" r="12" fill="none" stroke="#fff" stroke-width="3.6" />
              <line x1="29" y1="29" x2="40" y2="40" stroke="#fff" stroke-width="3.8" stroke-linecap="round" />
              <path d="M20 15v9" stroke="#fff" stroke-width="3.4" stroke-linecap="round" />
              <circle cx="20" cy="28.5" r="1.8" fill="#fff" />
            </svg>
          </div>
          <span class="quick-name">假央企名单</span>
        </div>
        <div class="quick-item" @click="scrollToService('cardAi')">
          <div class="quick-icon theme-ai">
            <svg viewBox="0 0 48 48" width="30" height="30" aria-hidden="true">
              <rect x="10" y="16" width="28" height="20" rx="7" fill="#fff" />
              <path d="M24 10v6" stroke="#fff" stroke-width="3.2" stroke-linecap="round" />
              <circle cx="24" cy="7.4" r="2.8" fill="#fff" />
              <rect x="16" y="23" width="5" height="5" rx="2.5" fill="#6C5CE7" />
              <rect x="27" y="23" width="5" height="5" rx="2.5" fill="#6C5CE7" />
              <path d="M16 33h16" stroke="#6C5CE7" stroke-width="2.6" stroke-linecap="round" />
            </svg>
          </div>
          <span class="quick-name">AI合同审核</span>
        </div>
        <div class="quick-item" @click="scrollToService('cardRisk')">
          <div class="quick-icon theme-risk">
            <svg viewBox="0 0 48 48" width="30" height="30" aria-hidden="true">
              <path d="M24 4l18 7v12c0 11-7.6 17.6-18 21C13.6 40.6 6 34 6 23V11z" fill="#fff" />
              <path d="M16 23l6 6 10-12" fill="none" stroke="#00A0C9" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <span class="quick-name">风控报告</span>
        </div>
      </nav>

      <!-- 01 合规自查表 -->
      <section ref="cardComp" class="module-card card-comp">
        <div class="module-head">
          <div class="module-icon">
            <svg viewBox="0 0 48 48" width="34" height="34" aria-hidden="true">
              <defs>
                <linearGradient id="gComp" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#FF5722" />
                  <stop offset="1" stop-color="#FF9800" />
                </linearGradient>
              </defs>
              <rect x="8" y="6" width="32" height="38" rx="5" fill="none" stroke="url(#gComp)" stroke-width="3" />
              <rect x="17" y="4" width="14" height="8" rx="2" fill="url(#gComp)" />
              <path d="M18 25l5 5 8-9" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="module-title">
            <h2>合规自查表</h2>
            <span class="en">COMPLIANCE SELF-CHECK</span>
          </div>
          <span class="g-badge comp-badge">自查</span>
        </div>

        <!-- 迷你表预览 -->
        <div class="mini-table">
          <div class="table-head">
            <span class="col-name">检查项</span>
            <span class="col-status">结果状态</span>
          </div>
          <div class="table-row" v-for="(item, i) in checkItems" :key="i">
            <div class="td-name">
              <p class="n">{{ item.name }}</p>
              <!-- <p class="t">{{ item.time }}</p> -->
            </div>
            <div class="td-status">
              <span class="status-tag" :class="'lv-' + item.level">{{ item.status }}</span>
            </div>
          </div>
        </div>

        <div class="module-actions">
          <button class="btn btn-solid btn-comp" @click="downloadExcel">下载完整 Excel</button>
          <button class="btn btn-ghost btn-comp" @click="goDetail('/guoqiComp')">查看全部</button>
        </div>
      </section>

      <!-- 02 假央企名单 -->
      <section ref="cardSoe" class="module-card card-soe">
        <div class="module-head">
          <div class="module-icon">
            <svg viewBox="0 0 48 48" width="34" height="34" aria-hidden="true">
              <defs>
                <linearGradient id="gSoe" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#E94B2B" />
                  <stop offset="1" stop-color="#FF7A3D" />
                </linearGradient>
              </defs>
              <circle cx="20" cy="20" r="12" fill="none" stroke="url(#gSoe)" stroke-width="3.4" />
              <line x1="29" y1="29" x2="40" y2="40" stroke="url(#gSoe)" stroke-width="3.6" stroke-linecap="round" />
              <path d="M20 15v9" stroke="#fff" stroke-width="3.2" stroke-linecap="round" />
              <circle cx="20" cy="28.5" r="1.7" fill="#fff" />
            </svg>
          </div>
          <div class="module-title">
            <h2>假央企名单</h2>
            <span class="en">FAKE SOE LIST</span>
          </div>
          <span class="g-badge soe-badge">危险</span>
        </div>

        <!-- 实时搜索 -->
        <div class="search-box">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <circle cx="11" cy="11" r="7" fill="none" stroke="#8A7D73" stroke-width="2.2" />
            <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="#8A7D73" stroke-width="2.4" stroke-linecap="round" />
          </svg>
          <input v-model="soeKeyword"
                 type="text"
                 placeholder="搜索企业名称 / 统一社会信用代码"
                 @input="soeFiltered" />
          <span class="search-clear" v-if="soeKeyword" @click="clearKw">×</span>
        </div>

        <!-- 统计数字 -->
        <div class="soe-stats">
          <div class="soe-stat">
            <div class="num">{{ soeTotal }}</div>
            <div class="lbl">累计收录</div>
          </div>
          <div class="soe-stat">
            <div class="num hot">{{ soeNewYear }}</div>
            <div class="lbl">今年新增</div>
          </div>
          <!-- <div class="soe-stat">
            <div class="num">1132</div>
            <div class="lbl">已核实</div>
          </div> -->
        </div>

        <!-- 最近曝光标签 -->
        <div class="soe-tags">
          <div class="tags-title">最近曝光</div>
        </div>

        <!-- 搜索预览列表 -->
        <div class="soe-list" v-if="soeList.length">
          <div class="soe-item" v-for="(item, i) in soeList" :key="i">
            <div class="soe-name">
              <span class="dot"></span>
              <p class="n">{{ item.companyName }}</p>
            </div>
            <div class="soe-meta" v-if="item.labels">
              <span>{{ item.labels }}</span>
            </div>
          </div>
        </div>
        <div class="soe-empty" v-else-if="soeReady">{{ soeKeyword ? '未匹配到相关企业，可点击下方提交线索' : '暂无涉假企业收录' }}</div>

        <div class="module-actions">
          <button class="btn btn-solid btn-soe" @click="goDetail('/guoqiSoe')">查看更多</button>
        </div>
      </section>

      <!-- 03 AI 合同审核 -->
      <section ref="cardAi" class="module-card card-ai">
        <span class="hot-corner">HOT</span>
        <div class="module-head">
          <div class="module-icon">
            <svg viewBox="0 0 48 48" width="34" height="34" aria-hidden="true">
              <defs>
                <linearGradient id="gAi" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#6C5CE7" />
                  <stop offset="1" stop-color="#0984E3" />
                </linearGradient>
              </defs>
              <rect x="10" y="16" width="28" height="20" rx="7" fill="url(#gAi)" />
              <path d="M24 10v6" stroke="url(#gAi)" stroke-width="3" stroke-linecap="round" />
              <circle cx="24" cy="7.4" r="2.6" fill="url(#gAi)" />
              <rect x="16" y="23" width="5" height="5" rx="2.5" fill="#fff" />
              <rect x="27" y="23" width="5" height="5" rx="2.5" fill="#fff" />
              <path d="M16 33h16" stroke="#fff" stroke-width="2.4" stroke-linecap="round" />
            </svg>
          </div>
          <div class="module-title">
            <h2>AI 合同审核</h2>
            <span class="en">AI CONTRACT REVIEW</span>
          </div>
          <span class="g-badge ai-badge">智能</span>
        </div>

        <!-- 拖拽上传 -->
        <div class="upload-area" :class="{ active: aiState !== 'idle' }" @click="startUpload">
          <template v-if="aiState === 'idle'">
            <div class="upload-icon">
              <svg viewBox="0 0 48 48" width="40" height="40" aria-hidden="true">
                <defs>
                  <linearGradient id="gAiUp" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#6C5CE7" />
                    <stop offset="1" stop-color="#0984E3" />
                  </linearGradient>
                </defs>
                <path d="M24 6l10 12h-6v12h-8V18h-6z" fill="url(#gAiUp)" />
                <path d="M10 34v6a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-6" fill="none" stroke="url(#gAiUp)" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <p class="up-tip">点击上传或拖拽文件至此处</p>
            <p class="up-sub">支持 PDF / Word 格式 · 单份 ≤ 50MB</p>
          </template>
          <template v-else>
            <div class="up-progress">
              <div class="up-ring" :style="{ background: 'conic-gradient(#6C5CE7 ' + aiProgress + '%, rgba(108,92,231,0.15) 0)' }">
                <div class="up-ring-inner">
                  <span v-if="aiState === 'analyzing'">审核中</span>
                  <span v-else-if="aiState === 'done'">✓</span>
                  <span v-else>上传中</span>
                </div>
              </div>
              <div class="up-bar">
                <div class="up-bar-fill" :style="{ width: aiProgress + '%' }"></div>
              </div>
              <p class="up-sub">{{ aiState === 'analyzing' ? 'AI 正在逐条识别条款风险…' : aiState === 'done' ? '审核完成，结果已生成' : '正在上传文件…' }}</p>
            </div>
          </template>
        </div>

        <!-- 最近审核记录 -->
        <div class="records">
          <div class="records-title">最近审核记录</div>
          <div class="record-item" v-for="(item, i) in aiRecords" :key="i" @click="goDetail('/guoqiAi')">
            <div class="rec-left">
              <p class="n">{{ item.name }}</p>
              <p class="t">{{ item.time }}</p>
            </div>
          </div>
        </div>

        <div class="module-actions">
          <button class="btn btn-solid btn-ai" @click="startUpload">开始智能审核</button>
          <button class="btn btn-ghost btn-ai" @click="goDetail('/guoqiAi')">审核记录</button>
        </div>
      </section>

      <!-- 04 风控报告 -->
      <section ref="cardRisk" class="module-card card-risk">
        <div class="module-head">
          <div class="module-icon">
            <svg viewBox="0 0 48 48" width="34" height="34" aria-hidden="true">
              <defs>
                <linearGradient id="gRisk" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stop-color="#00B8D9" />
                  <stop offset="1" stop-color="#00A0E9" />
                </linearGradient>
              </defs>
              <path d="M24 4l18 7v12c0 11-7.6 17.6-18 21C13.6 40.6 6 34 6 23V11z" fill="url(#gRisk)" />
              <path d="M16 23l6 6 10-12" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="module-title">
            <h2>风控报告</h2>
            <span class="en">RISK CONTROL REPORT</span>
          </div>
          <span class="g-badge risk-badge">安全</span>
        </div>

        <!-- 企业全称即时查询 -->
        <div class="query-box">
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <path d="M12 3l8 3v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6z" fill="none" stroke="#00A0C9" stroke-width="2" stroke-linejoin="round" />
            <path d="M9 12l2.2 2.2L15.5 9.5" fill="none" stroke="#00A0C9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input v-model="companyName"
                 type="text"
                 placeholder="输入企业全称，即时生成风控报告"
                 @keyup.enter="queryReport" />
          <button class="btn btn-solid btn-risk query-btn" @click="queryReport">立即查询</button>
        </div>

        <!-- 进度展示 -->
        <div class="running-report" v-if="runningReport">
          <div class="run-head">
            <span class="run-name">{{ runningReport.company }}</span>
          </div>
          <div class="run-bar">
            <div class="run-bar-fill" :style="{ width: runningReport.progress + '%' }"></div>
          </div>
          <p class="run-tip">{{ runningReport.progress >= 100 ? '报告已生成，可点击下载' : '正在交叉核验工商、司法、经营异常数据…' }}</p>
        </div>

        <!-- 最近查询历史 -->
        <div class="records">
          <div class="records-title">最近查询历史</div>
          <div class="record-item" v-for="(item, i) in riskHistory" :key="i" @click="goDetail('/guoqiRisk')">
            <div class="rec-left">
              <p class="n">{{ item.company }}</p>
              <p class="t">{{ item.time }}</p>
            </div>
            <span class="status-tag" :class="item.status === '已生成' ? 'lv-pass' : 'lv-run'">{{ item.status }}</span>
            <span class="download-link" v-if="item.status === '已生成'" @click.stop="simDownload(item.company + ' 风控报告')">下载</span>
          </div>
        </div>

        <div class="module-actions">
          <!-- <button class="btn btn-solid btn-risk" @click="queryReport">立即生成报告</button> -->
          <button class="btn btn-solid btn-risk" @click="goDetail('/guoqiRisk')">立即生成报告</button>
        </div>
      </section>
    </main>

    <!-- ============ 页脚 ============ -->
    <!-- <footer class="footer">
      数据来源：国资委 · 国家企业信用信息公示系统
    </footer> -->
  </div>
</template>

<script>
import { CHECK_EXCEL_URL, downloadFile } from '../utils/download'
import { reportDownload } from '../utils/pageAccess'
export default {
  name: 'guoqi',
  data () {
    return {
      // 合规自查表
      checkItems: [
        { name: '主责主业合规', time: '2 分钟前', status: '合规', level: 'low' },
        { name: '商业合理性合规', time: '1 小时前', status: '合规', level: 'low' },
        { name: '采购合规', time: '昨天', status: '待整改', level: 'mid' }
      ],
      // 假央企名单
      soeKeyword: '',
      soeList: [],     // 最近曝光列表：result.list（前 5 条）
      soeTotal: 0,     // 累计收录：result.total
      soeNewYear: 0,   // 今年新增：本年度创建记录数 result.total
      soeReady: false, // 首屏列表是否加载完成
      // AI 合同审核
      aiState: 'idle', // idle | uploading | analyzing | done
      aiProgress: 0,
      aiTimer: null,
      aiSeq: 3,
      aiRecords: [
        { name: '煤炭购销框架合同.docx', time: '5 分钟前', risk: '低风险', level: 'low' },
        { name: '供应链金融合作协议.pdf', time: '32 分钟前', risk: '高风险', level: 'high' },
        { name: '设备采购补充协议.docx', time: '2 小时前', risk: '中风险', level: 'mid' }
      ],
      // 风控报告
      companyName: '',
      runningReport: null,
      riskTimer: null,
      riskHistory: [
        { company: '国家能源集团有限责任公司', time: '10 分钟前', status: '已生成' },
        { company: '中国建筑集团有限公司', time: '1 小时前', status: '已生成' },
        { company: '中国中车股份有限公司', time: '昨天', status: '已生成' }
      ]
    }
  },
  computed: {
  },
  created () {
    this.share()
    this.getFakeSoe()
  },
  beforeDestroy () {
    clearInterval(this.aiTimer)
    clearInterval(this.riskTimer)
  },
  methods: {
    // ---- 微信分享（guoqi 页面独立配置，未使用 share mixin） ----
    share () {
      this.$api
        .get("/api/wechat/share/get", {
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          let that = this
          wx.config({
            debug: false, // 开启调试模式，可 alert 返回值和报错
            appId: res.result.appId,
            timestamp: res.result.timestamp,
            nonceStr: res.result.nonceStr,
            signature: res.result.signature,
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "updateTimelineShareData",
              "updateAppMessageShareData",
            ],
          });
          wx.ready(function () {
            let shareUrl = window.location.origin + window.location.pathname + `#/guoqi?id=${that.$route.query.id}&fromOpenId=${that.$cookies.get('openId')}&ladingPageId=${localStorage.getItem("ladingPageId")}&tenantId=${localStorage.getItem("tenantId")}`
            let logo = 'http://dm.zhongpukeji.cn/f/image/1788155228915.png'
            let title = '国企供应链贸易：合规自查表、AI合同审核、黑名单、风控报告等'
            let desc = ''
            wx.onMenuShareAppMessage({ title, desc, link: shareUrl, imgUrl: logo })
            wx.onMenuShareTimeline({ title, desc, link: shareUrl, imgUrl: logo })
            wx.updateTimelineShareData({ title, desc, link: shareUrl, imgUrl: logo })
            wx.updateAppMessageShareData({ title, desc, link: shareUrl, imgUrl: logo })
          });
          wx.error(function (res) {
            console.log('打印错误消息:', res.errMsg); // debug 时可用
          });
        });
    },
    simDownload (label) {
      this.$toast.loading({ message: '正在生成 ' + label + ' …', duration: 0, forbidClick: true })
      setTimeout(() => {
        this.$toast.clear()
        this.$toast.success('已开始下载')
      }, 900)
    },
    // 合规自查表 Excel：真实文件下载
    downloadExcel () {
      downloadFile(CHECK_EXCEL_URL, '自查表.xlsx')
      reportDownload({
        openId: this.$cookies.get('openId'),
        pageName: '合规自查表',
        filename: '自查表.xlsx',
        url: CHECK_EXCEL_URL
      })
      this.$toast.success('已开始下载')
    },
    more (name) {
      this.$toast(name + '：完整功能开放中，敬请期待')
    },
    goDetail (path) {
      this.$router.push(path)
    },
    // ---- 快速入口滚动定位 ----
    scrollToService (refName) {
      const el = this.$refs[refName]
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    // ---- 假央企名单 ----
    soeFiltered () {
      this.getFakeSoe()
    },
    clearKw () {
      this.soeKeyword = ''
      this.getFakeSoe()
    },
    // 假央企名单数据：最近曝光列表 + 累计收录 + 今年新增
    getFakeSoe () {
      const kw = this.soeKeyword.trim().toLowerCase()
      this.$api.post("/api/crm/blackList/list", {
        pageNum: 1,
        pageSize: 5,
        data: {},
        params: { 
          companyName$LIKE: kw,
          "labels$LIKE": "假央企"
        },
      }).then((res) => {
        if (res && res.result) {
          const list = res.result.list || []
          this.soeList = list
          this.soeTotal = res.result.total || 0
        }
        this.soeReady = true
      })
      // 今年新增：同接口仅统计本年度创建记录数（createTime$BEGIN 动态取当年 1 月 1 日）
      const yearStart = `${new Date().getFullYear()}-01-01`
      const yearEnd = `${new Date().getFullYear()}-12-31`
      this.$api.post("/api/crm/blackList/list", {
        pageNum: 1,
        pageSize: 10,
        data: {},
        params: { 
          "labels$LIKE": "假央企", 
          createTime$BEGIN: yearStart,
          createTime$END: yearEnd,
         },
      }).then((res) => {
        if (res && res.result) {
          this.soeNewYear = res.result.total || 0
        }
      })
    },
    soeTag (labels) {
      // labels 可能是数组或逗号/顿号分隔字符串
      const arr = Array.isArray(labels) ? labels : String(labels || '').split(/[,，、;；/]/)
      return arr.map((s) => String(s).trim()).find((s) => s && s !== '假央企') || ''
    },
    // ---- AI 合同审核 ----
    startUpload () {
      if (this.aiState !== 'idle') {
        return
      }
      this.aiState = 'uploading'
      this.aiProgress = 8
      clearInterval(this.aiTimer)
      this.aiTimer = setInterval(() => {
        this.aiProgress += 7
        if (this.aiProgress >= 52) {
          this.aiState = 'analyzing'
        }
        if (this.aiProgress >= 100) {
          clearInterval(this.aiTimer)
          this.aiProgress = 100
          this.aiState = 'done'
          this.$toast.success('AI 审核完成')
          this.aiRecords.unshift({
            name: '合同审核样本_' + String(this.aiSeq++).padStart(2, '0') + '.pdf',
            time: '刚刚',
            risk: '低风险',
            level: 'low'
          })
          setTimeout(() => {
            this.aiState = 'idle'
            this.aiProgress = 0
          }, 1400)
        }
      }, 90)
    },
    // ---- 风控报告 ----
    queryReport () {
      const name = this.companyName.trim()
      if (!name) {
        this.$toast('请输入企业全称')
        return
      }
      if (this.runningReport && this.runningReport.progress < 100) {
        this.$toast('已有报告正在生成，请稍候')
        return
      }
      const item = { company: name, time: '刚刚', status: '生成中', progress: 0, running: true }
      this.riskHistory.unshift(item)
      this.runningReport = item
      this.companyName = ''
      clearInterval(this.riskTimer)
      this.riskTimer = setInterval(() => {
        item.progress = Math.min(item.progress + 9, 100)
        if (item.progress >= 100) {
          clearInterval(this.riskTimer)
          item.status = '已生成'
          item.running = false
          this.$toast.success('风控报告已生成')
        }
      }, 130)
    }
  }
}
</script>

<style scoped lang="less">
@bg: #F8F4ED;
@navy: #0F1E3C;
@muted: #7A7265;
@orange: #FF5722;
@orange2: #FF9800;
@red: #E94B2B;
@purple: #6C5CE7;
@blue: #0984E3;
@lake: #00B8D9;

.guoqi {
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 40px;
  font-family: -apple-system, "PingFang SC", "Helvetica Neue", Helvetica, "Microsoft YaHei", sans-serif;
  color: @navy;
  background-color: @bg;
  background-image: radial-gradient(rgba(15, 30, 60, 0.05) 1px, transparent 1px);
  background-size: 22px 22px;

  /* ================= Hero ================= */
  .hero {
    position: relative;
    padding: 76px 30px 64px;
    overflow: hidden;
    background: linear-gradient(140deg, #FF5722 0%, #FF7A2B 45%, #FF9800 100%);
    color: #fff;

    .halo {
      position: absolute;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.32), transparent 70%);
      filter: blur(4px);
      animation: float 7s ease-in-out infinite;
    }
    .halo-a { width: 340px; height: 340px; top: -140px; right: -90px; }
    .halo-b { width: 240px; height: 240px; bottom: -100px; left: -70px; animation-delay: 2.4s; }

    .ring {
      position: absolute;
      border-radius: 50%;
      border: 2px dashed rgba(255, 255, 255, 0.35);
      animation: spin 22s linear infinite;
    }
    .ring-a { width: 220px; height: 220px; top: -80px; right: 60px; }
    .ring-b { width: 140px; height: 140px; bottom: 24px; left: 100px; animation-duration: 16s; animation-direction: reverse; }

    .tech-dots {
      position: absolute;
      inset: 0;
      background-image: radial-gradient(rgba(255, 255, 255, 0.16) 1.5px, transparent 1.5px);
      background-size: 30px 30px;
      pointer-events: none;
    }

    .hero-badge {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #FFF3EC;
      background: rgba(255, 255, 255, 0.16);
      border: 1px solid rgba(255, 255, 255, 0.28);
      border-radius: 999px;
      padding: 10px 22px;
      backdrop-filter: blur(6px);
      .badge-dot {
        width: 10px; height: 10px;
        border-radius: 50%;
        background: #FFE0A3;
        box-shadow: 0 0 0 5px rgba(255, 224, 163, 0.22);
        animation: pulse 1.6s infinite;
      }
    }

    .hero-title {
      position: relative;
      margin-top: 26px;
      font-size: 60px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 2px;
    }

    .hero-sub {
      position: relative;
      margin-top: 14px;
      font-size: 30px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.92);
      letter-spacing: 5px;
    }

    .hero-stats {
      position: relative;
      display: flex;
      margin-top: 38px;
      background: rgba(255, 255, 255, 0.14);
      border: 1px solid rgba(255, 255, 255, 0.24);
      border-radius: 24px;
      backdrop-filter: blur(8px);
      padding: 24px 8px;
      .hero-stat {
        flex: 1;
        text-align: center;
        border-right: 1px solid rgba(255, 255, 255, 0.18);
        &:last-child { border-right: none; }
        .num {
          font-size: 44px;
          font-weight: 700;
          line-height: 1;
          b { font-weight: 700; }
          em { font-style: normal; font-size: 22px; font-weight: 500; margin-left: 3px; opacity: 0.85; }
        }
        .lbl {
          margin-top: 12px;
          font-size: 22px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.82);
        }
      }
    }
  }

  /* ================= 模块卡片通用 ================= */
  .main {
    padding: 0 24px;
  }

  /* ================= 快速入口 ================= */
  .quick-nav {
    position: relative;
    z-index: 3;
    display: flex;
    margin-top: 30px;
    padding: 30px 6px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.82);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 12px 34px rgba(15, 30, 60, 0.12);

    .quick-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      cursor: pointer;

      .quick-icon {
        width: 58px; height: 58px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 16px rgba(15, 30, 60, 0.12);
        transition: transform 0.15s ease;
      }
      .quick-name {
        font-size: 22px;
        font-weight: 600;
        color: @navy;
        white-space: nowrap;
      }
      &:active .quick-icon { transform: scale(0.92); }
    }
  }
  .theme-comp { background: linear-gradient(135deg, #FF6B2B, #FFB03A); }
  .theme-soe  { background: linear-gradient(135deg, #E94B2B, #FF7A3D); }
  .theme-ai   { background: linear-gradient(135deg, #6C5CE7, #0984E3); }
  .theme-risk { background: linear-gradient(135deg, #00B8D9, #00A0E9); }

  .module-card {
    position: relative;
    overflow: hidden;
    margin-top: 28px;
    padding: 30px 28px 32px;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 0.85);
    box-shadow: 0 14px 40px rgba(15, 30, 60, 0.08);

    &::before {
      content: '';
      position: absolute;
      top: -70px; right: -70px;
      width: 220px; height: 220px;
      border-radius: 50%;
      filter: blur(46px);
      opacity: 0.4;
      pointer-events: none;
    }
    &::after {
      content: '';
      position: absolute;
      top: 0; left: 28px; right: 28px;
      height: 4px;
      border-radius: 0 0 4px 4px;
      opacity: 0.9;
    }

    .module-head {
      position: relative;
      display: flex;
      align-items: center;
      gap: 16px;

      .module-icon {
        width: 64px; height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 22px rgba(15, 30, 60, 0.12);
      }

      .module-title {
        flex: 1;
        h2 { font-size: 36px; font-weight: 700; line-height: 1.2; }
        .en {
          display: block;
          margin-top: 6px;
          font-size: 22px;
          font-weight: 400;
          letter-spacing: 1.6px;
          opacity: 0.55;
        }
      }

      .g-badge {
        font-size: 24px;
        font-weight: 600;
        color: #fff;
        padding: 8px 20px;
        border-radius: 999px;
        letter-spacing: 1px;
      }
    }

    .module-actions {
      position: relative;
      display: flex;
      gap: 16px;
      margin-top: 30px;

      .btn {
        flex: 1;
        height: 60px;
        border-radius: 999px;
        border: none;
        font-size: 28px;
        font-weight: 600;
        font-family: inherit;
        cursor: pointer;
        transition: transform 0.15s ease, box-shadow 0.15s ease;
        &:active { transform: scale(0.97); }
      }
      .btn-solid { color: #fff; box-shadow: 0 8px 18px rgba(15, 30, 60, 0.16); }
      .btn-ghost { background: rgba(255, 255, 255, 0.7); }
    }
  }

  /* ================= 各模块配色 ================= */
  .card-comp::after { background: linear-gradient(90deg, #FF5722, #FF9800); }
  .card-comp::before { background: linear-gradient(135deg, #FF5722, #FF9800); }
  .card-comp .module-icon { background: linear-gradient(135deg, #FF6B2B, #FFB03A); }
  .card-comp .g-badge { background: linear-gradient(135deg, #FF9800, #FF5722); }
  .btn-comp.btn-solid { background: linear-gradient(135deg, #FF5722, #FF9800); }
  .btn-comp.btn-ghost { color: #FF6B22; border: 1px solid #FFD9B8; }

  .card-soe::after { background: linear-gradient(90deg, #E94B2B, #FF7A3D); }
  .card-soe::before { background: linear-gradient(135deg, #E94B2B, #FF7A3D); }
  .card-soe .module-icon { background: linear-gradient(135deg, #E94B2B, #FF7A3D); }
  .card-soe .g-badge { background: linear-gradient(135deg, #E94B2B, #FF5F2E); }
  .btn-soe.btn-solid { background: linear-gradient(135deg, #E94B2B, #FF7A3D); }
  .btn-soe.btn-ghost { color: #E94B2B; border: 1px solid #F5C4B8; }

  .card-ai::after { background: linear-gradient(90deg, #6C5CE7, #0984E3); }
  .card-ai::before { background: linear-gradient(135deg, #6C5CE7, #0984E3); }
  .card-ai .module-icon { background: linear-gradient(135deg, #6C5CE7, #0984E3); }
  .card-ai .g-badge { background: linear-gradient(135deg, #6C5CE7, #0984E3); }
  .btn-ai.btn-solid { background: linear-gradient(135deg, #6C5CE7, #0984E3); }
  .btn-ai.btn-ghost { color: #6C5CE7; border: 1px solid #C8C2F2; }

  .card-risk::after { background: linear-gradient(90deg, #00B8D9, #00A0E9); }
  .card-risk::before { background: linear-gradient(135deg, #00B8D9, #00A0E9); }
  .card-risk .module-icon { background: linear-gradient(135deg, #00B8D9, #00A0E9); }
  .card-risk .g-badge { background: linear-gradient(135deg, #00B8D9, #00A0E9); }
  .btn-risk.btn-solid { background: linear-gradient(135deg, #00B8D9, #00A0E9); }
  .btn-risk.btn-ghost { color: #0099C9; border: 1px solid #B5E7F2; }

  /* ================= 01 合规自查表 ================= */
  .mini-table {
    position: relative;
    margin-top: 24px;
    border-radius: 18px;
    background: rgba(255, 250, 244, 0.85);
    padding: 8px 20px;
    font-size: 24px;

    .table-head {
      display: flex;
      padding: 14px 0 10px;
      font-weight: 500;
      opacity: 0.45;
      .col-name { flex: 1; }
      .col-status { width: 116px; text-align: center; }
      .col-score { width: 96px; text-align: right; }
    }

    .table-row {
      display: flex;
      align-items: center;
      padding: 16px 0;
      border-top: 1px dashed rgba(15, 30, 60, 0.08);

      .td-name { flex: 1; min-width: 0; }
      .n {
        font-size: 30px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .t { margin-top: 5px; font-size: 22px; opacity: 0.5; }
      .td-status { width: 116px; text-align: center; }
      .td-score {
        width: 96px;
        text-align: right;
        .score-capsule {
          display: inline-block;
          min-width: 70px;
          text-align: center;
          font-size: 28px;
          font-weight: 700;
          padding: 5px 12px;
          border-radius: 999px;
          em { font-style: normal; font-size: 18px; font-weight: 500; margin-left: 2px; }
        }
      }
    }
  }

  /* ================= 状态标签 ================= */
  .status-tag {
    display: inline-block;
    font-size: 22px;
    font-weight: 600;
    padding: 5px 14px;
    border-radius: 999px;
    white-space: nowrap;
  }
  .lv-low { color: #0F9D5C; background: #E3F7EC; }
  .lv-mid { color: #D97706; background: #FCF0DC; }
  .lv-high { color: #E11D48; background: #FCE6E9; }
  .lv-pass { color: #0B7AC2; background: #E3F2FC; }
  .lv-run { color: #7A6CF0; background: #EEEAFE; }
  .score-capsule.lv-low { color: #0F9D5C; background: #E3F7EC; }
  .score-capsule.lv-mid { color: #D97706; background: #FCF0DC; }
  .score-capsule.lv-pass { color: #0B7AC2; background: #E3F2FC; }

  /* ================= 02 假央企名单 ================= */
  .search-box {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
    height: 58px;
    padding: 0 18px;
    border-radius: 999px;
    background: rgba(255, 244, 240, 0.9);
    border: 1px solid #F7D4C9;

    input {
      flex: 1;
      min-width: 0;
      border: none;
      outline: none;
      background: transparent;
      font-size: 26px;
      font-family: inherit;
      color: @navy;
      &::placeholder { color: #B09A90; }
    }
    .search-clear {
      color: #B0A297;
      font-size: 34px;
      line-height: 1;
      padding: 0 2px;
      cursor: pointer;
    }
  }

  .soe-stats {
    position: relative;
    display: flex;
    margin-top: 24px;
    .soe-stat {
      flex: 1;
      text-align: center;
      .num {
        font-size: 50px;
        font-weight: 700;
        color: #E94B2B;
        line-height: 1;
        &.hot {
          color: #fff;
          background: linear-gradient(135deg, #E94B2B, #FF7A3D);
          display: inline-block;
          min-width: 78px;
          padding: 6px 14px;
          border-radius: 999px;
          font-size: 38px;
          box-shadow: 0 6px 14px rgba(233, 75, 43, 0.32);
        }
      }
      .lbl { margin-top: 12px; font-size: 22px; opacity: 0.5; }
    }
  }

  .soe-tags {
    position: relative;
    margin-top: 24px;
    .tags-title { font-size: 26px; font-weight: 600; }
    .tags-wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin-top: 14px;
      .expose-tag {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 24px;
        font-weight: 500;
        color: #C0391F;
        background: rgba(233, 75, 43, 0.08);
        border: 1px solid rgba(233, 75, 43, 0.28);
        border-radius: 10px;
        padding: 8px 16px;
        i {
          width: 7px; height: 7px;
          border-radius: 50%;
          background: #E94B2B;
          animation: pulse 1.6s infinite;
        }
      }
    }
  }

  .soe-list {
    position: relative;
    margin-top: 20px;
    border-radius: 18px;
    background: rgba(255, 250, 248, 0.85);
    padding: 8px 20px;
    .soe-item {
      padding: 16px 0;
      border-bottom: 1px dashed rgba(15, 30, 60, 0.08);
      &:last-child { border-bottom: none; }
      .soe-name { display: flex; align-items: center; gap: 10px; }
      .dot {
        width: 8px; height: 8px;
        border-radius: 50%;
        background: #E94B2B;
        flex-shrink: 0;
      }
      .n {
        flex: 1;
        font-size: 28px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .risk-tag {
        flex-shrink: 0;
        font-size: 20px;
        font-weight: 600;
        padding: 4px 10px;
        border-radius: 999px;
        &.lv-high { color: #E11D48; background: #FCE6E9; }
        &.lv-mid { color: #D97706; background: #FCF0DC; }
      }
      .soe-meta {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        padding-left: 18px;
        font-size: 22px;
        opacity: 0.5;
      }
    }
  }
  .soe-empty {
    position: relative;
    margin-top: 20px;
    text-align: center;
    font-size: 24px;
    color: #B09A90;
    background: rgba(255, 250, 248, 0.85);
    border-radius: 18px;
    padding: 24px 0;
  }

  /* ================= 03 AI 合同审核 ================= */
  .hot-corner {
    position: absolute;
    top: -12px;
    right: 24px;
    z-index: 2;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 1px;
    background: linear-gradient(135deg, #FF2D55, #FF6B35);
    padding: 8px 18px;
    border-radius: 12px 12px 12px 0;
    box-shadow: 0 8px 18px rgba(255, 45, 85, 0.35);
    animation: pulse 1.7s infinite;
    &::after {
      content: '';
      position: absolute;
      right: 0; bottom: -10px;
      border: 5px solid transparent;
      border-top-color: #D92A45;
      border-right-color: #D92A45;
    }
  }

  .upload-area {
    position: relative;
    margin-top: 24px;
    padding: 34px 20px 30px;
    text-align: center;
    border-radius: 20px;
    border: 2px dashed rgba(108, 92, 231, 0.5);
    background: linear-gradient(180deg, rgba(108, 92, 231, 0.05), rgba(9, 132, 227, 0.05));
    cursor: pointer;
    transition: border-color 0.2s ease, transform 0.15s ease;
    &:active { transform: scale(0.99); }
    &.active {
      border-style: solid;
      border-color: rgba(108, 92, 231, 0.6);
      background: linear-gradient(180deg, rgba(108, 92, 231, 0.08), rgba(9, 132, 227, 0.08));
    }

    .upload-icon {
      width: 68px; height: 68px;
      margin: 0 auto;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 10px 22px rgba(108, 92, 231, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .up-tip { margin-top: 18px; font-size: 30px; font-weight: 600; }
    .up-sub { margin-top: 8px; font-size: 22px; opacity: 0.5; }

    .up-progress {
      .up-ring {
        width: 84px; height: 84px;
        margin: 0 auto;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.1s linear;
        .up-ring-inner {
          width: 64px; height: 64px;
          border-radius: 50%;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          font-weight: 600;
          color: #6C5CE7;
        }
      }
      .up-bar {
        margin-top: 18px;
        height: 10px;
        border-radius: 999px;
        background: rgba(108, 92, 231, 0.12);
        overflow: hidden;
        .up-bar-fill {
          height: 100%;
          border-radius: 999px;
          background: linear-gradient(90deg, #6C5CE7, #0984E3);
          transition: width 0.1s linear;
        }
      }
    }
  }

  /* ================= 记录列表（AI / 风控共用） ================= */
  .records {
    position: relative;
    margin-top: 24px;
    .records-title { font-size: 26px; font-weight: 600; }
    .record-item {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-top: 12px;
      padding: 16px 18px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.7);
      border: 1px solid rgba(15, 30, 60, 0.06);
      cursor: pointer;

      .rec-left { flex: 1; min-width: 0; }
      .n {
        font-size: 30px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .t { margin-top: 5px; font-size: 22px; opacity: 0.5; }

      .download-link {
        flex-shrink: 0;
        font-size: 24px;
        font-weight: 600;
        color: #00A0C9;
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 999px;
        background: rgba(0, 184, 217, 0.1);
        border: 1px solid rgba(0, 184, 217, 0.3);
      }
    }
  }

  /* ================= 04 风控报告 ================= */
  .query-box {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
    height: 60px;
    padding-left: 18px;
    border-radius: 18px;
    background: rgba(231, 248, 250, 0.9);
    border: 1px solid #C4EAF0;

    input {
      flex: 1;
      min-width: 0;
      border: none;
      outline: none;
      background: transparent;
      font-size: 26px;
      font-family: inherit;
      color: @navy;
      &::placeholder { color: #8FB7BF; }
    }
    .query-btn {
      flex: none;
      width: 180px;
      height: 52px;
      margin-right: 4px;
      font-size: 26px;
    }
  }

  .running-report {
    position: relative;
    margin-top: 18px;
    padding: 18px;
    border-radius: 16px;
    background: linear-gradient(135deg, rgba(0, 184, 217, 0.08), rgba(0, 160, 233, 0.08));
    border: 1px solid #C4EAF0;

    .run-head { display: flex; align-items: center; gap: 10px; }
    .run-name {
      flex: 1;
      font-size: 26px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .run-bar {
      margin-top: 14px;
      height: 10px;
      border-radius: 999px;
      background: rgba(0, 184, 217, 0.14);
      overflow: hidden;
      .run-bar-fill {
        height: 100%;
        border-radius: 999px;
        background: linear-gradient(90deg, #00B8D9, #00A0E9);
        transition: width 0.13s linear;
      }
    }
    .run-tip { margin-top: 10px; font-size: 22px; color: #5FA9B8; }
  }

  /* ================= 页脚 ================= */
  .footer {
    padding: 40px 30px 10px;
    text-align: center;
    font-size: 22px;
    font-weight: 400;
    color: #A79B8D;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
}
</style>
